import { render, staticRenderFns } from "./VetMembershipCard.vue?vue&type=template&id=52d6caf4&scoped=true"
import script from "./VetMembershipCard.vue?vue&type=script&lang=js"
export * from "./VetMembershipCard.vue?vue&type=script&lang=js"
import style0 from "./VetMembershipCard.vue?vue&type=style&index=0&id=52d6caf4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d6caf4",
  null
  
)

export default component.exports